import splitUrl from './splitUrl';

// Append `next` query parameter to a URL, if provided.
const urlWithNext = (url, next) => {
  if (!next) {
    return url;
  }
  const { baseHref, queryString } = splitUrl(url);
  const separator = queryString ? '&' : '';
  const nextQuery = next ? `${separator}next=${encodeURIComponent(next)}` : '';
  return `${baseHref}?${queryString}${nextQuery}`;
};

export default urlWithNext;
